import React, { lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import PublicLayout from '../Layout/PublicLayout';

const HomePage = lazy(() => import('../pages/Home/HomePage'));
const PublicHome = lazy(() => import('../pages/Home/PublicHome'));
const AuthRegister = lazy(() => import('../pages/Auth/AuthRegister'));
const PasswordReset = lazy(() => import('../pages/Auth/PasswordReset'));
const AboutUs = lazy(() => import('../pages/Home/AboutUs'));
const ContactUs = lazy(() => import('../pages/Home/ContactUs'));
const TermsAndConditions = lazy(() => import('../pages/Home/TermsAndConditions'));
const PrivacyPolicy = lazy(() => import('../pages/Legal/PrivacyPolicy'));
const ETFCategoryCards = lazy(() => import('../pages/Dashboard/ETFCategoryCards/ETFCategoryCards'));
const ETFCategoryDetail = lazy(() => import('../pages/Dashboard/ETFCategoryCards/ETFCategoryDetail'));
const ETFHoldings = lazy(() => import('../pages/Dashboard/ETFCategoryCards/ETFHoldings'));
const NotFound = lazy(() => import('../pages/NotFound/NotFound'));

// Public routes that don't require authentication
export const PublicRoutes = [
  {
    path: '/',
    element: <PublicLayout />,
    children: [
      {
        path: '',
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <HomePage />
          </Suspense>
        ),
      },
      {
        path: 'about',
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <AboutUs />
          </Suspense>
        ),
      },
      {
        path: 'contact',
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <ContactUs />
          </Suspense>
        ),
      },
      {
        path: 'terms',
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <TermsAndConditions />
          </Suspense>
        ),
      },
      {
        path: 'privacy',
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <PrivacyPolicy />
          </Suspense>
        ),
      },
      {
        path: 'login',
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <PublicHome />
          </Suspense>
        ),
      },
      {
        path: 'signup',
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <AuthRegister />
          </Suspense>
        ),
      },
      {
        path: 'reset-password',
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <PasswordReset />
          </Suspense>
        ),
      },
      {
        path: 'dashboard',
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <ETFCategoryCards />
          </Suspense>
        ),
      },
      {
        path: 'dashboard/etf-categories',
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <ETFCategoryCards />
          </Suspense>
        ),
      },
      {
        path: 'dashboard/etf/:slug',
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <ETFCategoryDetail />
          </Suspense>
        ),
      },
      {
        path: 'dashboard/etf/:slug/:ticker',
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <ETFHoldings />
          </Suspense>
        ),
      },
      // Sprint 19. Any public address with no page of its own.
      {
        path: '*',
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <NotFound />
          </Suspense>
        ),
      },
    ],
  },
  // Redirect old /public routes to new locations
  {
    path: '/public',
    element: <Navigate to="/" replace />,
  },
  {
    path: '/public/*',
    element: <Navigate to="/" replace />,
  },
];
